export const environment = {
  production: false,
  projectName: 'CSGOFAST',
  IS_FAST_COINS_ENABLED: true,
  GATEWAY_URL: 'https://sorrow-back-new.devfast.io',
  STATIC_URL: 'https://static.csgofast.com'
};
